import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';

import { useTokenLoginMutation } from '@features/shared/api';
import { SiteLayout } from '@features/shared/ui/SiteLayout/SiteLayout';
import { SiteLogoWidget } from '@features/shared/ui/SiteLogo/SiteLogoWidget';

import { LoginByTokenPage } from './LoginByTokenPage';

type Props = {
  token?: string;
  back?: string;
};

export function LoginByTokenPageWidget({ token, back }: Props) {
  const navigate = useNavigate();
  const mutation = useTokenLoginMutation();

  const destination = back ?? '/club';

  useEffect(() => {
    if (!token) {
      navigate({ to: '/', replace: true });
    }
  }, [token, navigate]);

  useEffect(() => {
    const mutate = mutation.mutate;
    if (token) {
      mutate({ token });
    }
  }, [token, mutation.mutate]);

  useEffect(() => {
    if (mutation.isSuccess) {
      navigate({ to: destination, replace: true });
    }
  }, [mutation.isSuccess, navigate, destination]);

  const status = mutation.isError ? 'error' : 'loading';

  return (
    <SiteLayout siteLogo={<SiteLogoWidget />}>
      <LoginByTokenPage status={status} />
    </SiteLayout>
  );
}
